export default "__VITE_ASSET__BFKLOoPN__"